export interface State {
  messagesViewed: {[fileNumber: string]: number};
}

export const initialState: State = {
  messagesViewed: {}
};

const VIEWED_MESSAGE = 'claims/VIEWED_MESSAGE';

export const viewedMessage = (fileNumber: string, count: number | 0) => ({
  type: VIEWED_MESSAGE,
  fileNumber,
  count
});
const messages = (state: State = initialState, action: any) => {
  switch (action.type) {
    case VIEWED_MESSAGE:
      if (state.messagesViewed[action.fileNumber]) {
        return state;
      }
      const newMessageViewedList = {...state.messagesViewed, [action.fileNumber]: action.count};
      return {...state, messagesViewed: newMessageViewedList};

    default:
      return state;
  }
};

export default messages;
